module.exports = __webpack_public_path__ + "assets/img/LIGHTINSIGHTS.a5d9533e.png";